<template>
  <div
    :id="{ 'mini-browser': showTiHeader }"
    class="relative mx-auto bg-gray-300 h-full"
    :class="{ 'mini-browser': showTiHeader }"
  >
    <div v-if="showTiHeader" class="mini-browser-header flex justify-between">
      <div>{{ miniBrowserHeader.productName }}</div>
      <div class="btn-close cursor-pointer close close_event" id="btnClsMini">
        <svg width="24" height="24" class="w-6 h-6 fill-current text-gray-700" viewBox="0 0 24 24">
          <path :d="mdiClose" />
        </svg>
      </div>
    </div>

    <div
      class="bg-gray-300 w-full"
      :class="{
        'mini-browser-content': showTiHeader,
        'h-full flex flex-col': !showTiHeader,
      }"
    >
      <MobileHeader />

      <main class="bg-gray-300 flex-auto flex-shrink-0 w-full my-0 mx-auto">
        <div class="flex justify-center px-4 pb-4">
          <div class="form-card bg-white border border-gray-100 w-full">
            <router-view></router-view>
          </div>
        </div>
      </main>

      <MobileFooter />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mdiClose } from '@mdi/js';
import MobileHeader from './../MobileHeader';
import MobileFooter from './../MobileFooter';

export default {
  name: 'SSOLayout',
  components: {
    MobileHeader,
    MobileFooter,
  },
  computed: {
    ...mapState(['miniBrowserHeader']),
  },
  data() {
    return {
      mdiClose,
      showTiHeader: false,
    };
  },
  mounted() {
    this.showTiHeader = navigator.userAgent.includes('uiWinMgr');

    if (this.showTiHeader) window.resizeTo(836, 626);
  },
};
</script>

<style lang="sass" scoped>
.form-card
  max-width: 480px
  padding: 40px
  border-radius: 16px

  @media (max-width: 720px)
    padding: 24px

/* mini browser header */
.mini-browser
  width: 800px
  height: 600px
  border-radius: 8px
  box-shadow: 0 2px 12px rgba(0,0,0,.25)
  overflow: hidden

.mini-browser-header
  background: rgba(250, 250, 250, 0.85)
  box-shadow: inset 0px -1px 0px #C9C9C9
  padding: 9px 8px 10px 16px
  font-size: 14px
  line-height: 19px
  color: #333

.mini-browser-content
  height: 557px
  overflow: scroll
  overflow-x: hidden

.btn-close
  padding-left: 8px
  border-left: 1px solid rgba(0, 0, 0, 0.15)
</style>
